export const CDN_BASE_URL = 'https://cdn.figure.com';
